import { Dialog, DialogContent } from '@mui/material';

function ModalComponent(props: any) {
    const [modalIsOpen, setIsOpen] = props.modalIsOpen;

    return (
        <Dialog
            open={modalIsOpen}
            onClose={() => setIsOpen(false)}
            maxWidth="md"
            PaperProps={{
                sx: {
                    minWidth: 500,
                    borderRadius: 1,
                    m: 0,
                    '& .MuiDialogContent-root': {
                        p: 0,
                    },
                }
            }}
        >
            <DialogContent>
                {props.children}
            </DialogContent>
        </Dialog>
    );
}

export default ModalComponent;
